import styled from "styled-components";
/**
 * ! Overlay
 * * AslanSN - 22-07-03
 * @returns Styled Component - styled library
 */
export const Overlay = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
`;
